import { PipeTransform, Pipe } from '@angular/core';
import { enumToList } from '../enum-to-list';
import { IdName } from './../../models/id-name.model';
import { MtReportSubject } from './../../enums/mt-report-subject.enum';

@Pipe({
  name: 'mtReportSubject',
  standalone: false
})
export class MtReportSubjectPipe implements PipeTransform {
  public transform(value: MtReportSubject): string {
    return getMtReportSubject(value);
  }
}

export function getMtReportSubject(value: MtReportSubject): string {
  switch (value) {
    case MtReportSubject.Mentee:
      return 'Mentee';
    case MtReportSubject.Mentor:
      return 'Mentor';
    default:
      throw new Error(`Unsupported value for MtReportSubject: ${value}.`);
  }
}

export function getMtReportSubjectList(): IdName[] {
  return enumToList(MtReportSubject, getMtReportSubject);
}
